module.exports = __webpack_public_path__ + "img/13.0ace1017.png";